import { Pipe, PipeTransform } from '@angular/core'
import * as moment_ from 'moment'
const moment = moment_

@Pipe({
  name: 'dateWithoutTime',
  standalone: false
})
export class DateWithoutTime implements PipeTransform {
  transform(value: any, ...args: any[]) {
    let dt = value
    if (!value.getFullYear) {
      dt = new Date(dt)
    }

    return moment.utc(dt).format('MM/DD/YYYY')
  }
}
